import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { routePaths } from 'components/Routes/data';
import ConfirmationStep from './ConfirmationStep';

const UpdateSalaryRegisterView = () => {
  return (
    <Switch>
      <Route
        path={routePaths.reports.updateSalaryRegister.confirmation}
        component={ConfirmationStep}
        exact
      />

      <Route>
        <Redirect to={routePaths.unknown} />
      </Route>
    </Switch>
  );
};

export default UpdateSalaryRegisterView;
